import { BlockType, UpdateBlockType } from "../../types/block/type";
import { useUpdateBlockMutation } from "./useUpdateBlockMutation";

export const useSelectBlockUpdateMutation = () => {
  const updateCalendarBlockMutate = useUpdateBlockMutation();

  const selectAndCallProperApi = async (
    id: number,
    payload: UpdateBlockType,
    prevData: BlockType
  ): Promise<any> => {
    const result = await updateCalendarBlockMutate.mutateAsync({
      id: id,
      payload,
      prevData: prevData,
    });

    return result;
  };

  return { selectAndCallProperApi };
};
